import { render, staticRenderFns } from "./ExportacionFacturas.vue?vue&type=template&id=2164f67a&scoped=true&"
import script from "./ExportacionFacturas.vue?vue&type=script&lang=js&"
export * from "./ExportacionFacturas.vue?vue&type=script&lang=js&"
import style0 from "./ExportacionFacturas.vue?vue&type=style&index=0&id=2164f67a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2164f67a",
  null
  
)

export default component.exports